import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuIndicator,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  NavigationMenuViewport,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { buttonVariants, Button } from "@/components/ui/button";
import { PhoneIcon } from "@/components/landing-page/parts/Icons";
import { SmapyLogo } from "@/components/layout/SmapyLogo";
import Image from "next/image";
import { Bell } from "lucide-react";
import { useTranslation } from "next-i18next";
import { useSessionContext } from "@supabase/auth-helpers-react";
import { WhatsappSupportUrl } from "@/utils/constants";
import type { ReactNode } from "react";

interface PageHeaderProps {
  backgroundImage?: string;
  children?: ReactNode;
  className?: string;
}

const defaultBackgroundImage = "/images/howDoesItWork-banner.png";

export const PageHeader = ({
  backgroundImage,
  children,
  className,
}: PageHeaderProps) => {
  const headerStyle = {
    backgroundImage: backgroundImage
      ? `url(${backgroundImage})`
      : `url(${defaultBackgroundImage})`,
  };

  const { t } = useTranslation("common");

  return (
    <section
      className={
        `DesktopBackgroundImage flex h-[380px] flex-col items-center justify-start bg-white bg-cover bg-left-top bg-no-repeat px-4 md:h-[730px] 2xl:h-[1030px] ` +
        className
      }
      style={headerStyle}
    >
      <div className="mx-auto flex w-full max-w-full justify-between overflow-auto md:container md:pt-2">
        <Link href="/">
          <div className="relative h-[70px] w-[100px] md:h-[100px] md:w-[250px]">
            <Image
              src="/images/mobile-logo.svg"
              fill
              sizes="100vw"
              alt="logo"
            />
          </div>
        </Link>
        <div className="flex flex-row items-center gap-2">
          {children}
          <a
            target="_blank"
            href={WhatsappSupportUrl}
            rel="noopener noreferrer"
          >
            <span className="flex flex-nowrap gap-1 sm:mx-4">
              <span className="mt-3 text-xs text-[#6E798C] sm:mt-2 sm:text-base">
                {t("whatsapp.support")}
              </span>
              <Image
                src="/images/whatsapp-icon.svg"
                width={35}
                height={35}
                alt="logo"
              />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};
